import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import {
  IKeyValueInterface,
  WeGoAuthorizedLink,
  Permission,
  PermissionType
} from "./../../shared/config";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { VehicleModel, VehicleBlockModel } from "../models/vehicle.model";
import { VehicleService } from "../models/vehicle.service";
import { Observable } from "rxjs/Observable";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from "../../shared/config";

@Component({
  selector: "wego-vehicle",
  template: require('../views/vehicle-list.component.html'),
  providers: [VehicleService]
})
export class VehicleListComponent implements OnInit {
  addVehicleLink: WeGoAuthorizedLink;
  urlVehicleAdd: string;
  DataListModel: DataListModel;
  vehicleList: VehicleModel[];
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  isLoading: boolean;
  deleteVehicleMasterHashId: string;
  blockVehicleMasterHashId: string;
  blockFlag: boolean;
  message: string;
  blockState: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  model: VehicleBlockModel;
  ownerCompanyHashID: string = "";
  sharedVehicleGroupHashId: string = "";
  lblAvailable: string;
  lblUnavailable: string;
  urlVehicleInfo: string;
  urlVehicleFutureBookingList: string;
  LblFualRequire: string;
  LblFualNotRequire: string;
  LblCleanRequire: string;
  LblCleanNotRequire: string;
  LblVehiclDamaged: string;
  LblVehicleNotDamaged: string;

  // list page filter variable
  chkCleanRequireFilter: boolean = false;
  chkFuelRequireFilter: boolean = false;
  chkDamageFilter: boolean = false;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("childModal") public childModal: any;
  @ViewChild("blockModal") public blockModal: any;

  urlDefaultPage: string;
  urlVehicleUpdate: string;
  //urlVehicleSVGList: string;
  urlSharedVehicleGroupList: string;

  get isAnyChecked(): boolean {
    if (this.vehicleList) {
      let isCheck = this.vehicleList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.vehicleList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.vehicleList) {
      return this.vehicleList.some(x => x.isDeletable);
    } else {
      return false;
    }
  }

  constructor(
    private vehicleService: VehicleService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.lblAvailable = this.translate.instant("LblAvailable");
    this.lblUnavailable = this.translate.instant("LblUnAvailable");
    this.LblFualNotRequire = this.translate.instant("LblFualNotRequire");
    this.LblFualRequire = this.translate.instant("LblFualRequire");
    this.LblCleanNotRequire = this.translate.instant("LblCleanNotRequire");
    this.LblCleanRequire = this.translate.instant("LblCleanRequire");
    this.LblVehiclDamaged = this.translate.instant("LblVehiclDamaged");
    this.LblVehicleNotDamaged = this.translate.instant("LblVehicleNotDamaged");
    this.module = this.translate.instant("LblVehicle");
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
    this.urlSharedVehicleGroupList = this.authService.GetURL(
      ApplicationRouteURL.URL_SVG_LIST
    );

    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.model = new VehicleBlockModel();
    this.DataListModel.searchField = [
      "licenceTag",
      "ownerName",
      "brand",
      "type",
      "vehicleClass",
      "color"
    ];
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );

    this.urlVehicleAdd = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_ADD
    );

    this.urlVehicleUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_UPDATE
    );
    // this.urlVehicleSVGList = this.authService.GetURL(
    //   ApplicationRouteURL.URL_VEHICLE_SVG_LIST
    // );
    this.urlVehicleInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_INFO
    );
    this.urlVehicleFutureBookingList = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST
    );

    this.activeRoute.params.subscribe(params => {
      let ownerCompanyHashID = params["ownerCompanyHashID"] || "";
      let sharedVehicleGroupHashId = params["sharedVehicleGroupHashId"] || "";
      if (ownerCompanyHashID != "")
        this.ownerCompanyHashID = ownerCompanyHashID;
      else this.ownerCompanyHashID = "";
      if (sharedVehicleGroupHashId != "")
        this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
      else this.sharedVehicleGroupHashId = "";

      this.GetVehicleList();
    });

    this.addVehicleLink = new WeGoAuthorizedLink(
      this.urlVehicleAdd,
      Permission.PR_VEHICLES_OVERVIEW,
      PermissionType.INSERT,
      "btn btn-highlight navbar-right",
      "LblAddNew"
    );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetVehicleList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleList();
  }

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.vehicleService
      .ExportVehicleList(
        this.DataListModel,
        this.ownerCompanyHashID,
        this.sharedVehicleGroupHashId,
        null,
        false,
        this.chkCleanRequireFilter,
        this.chkFuelRequireFilter,
        this.chkDamageFilter
      )
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "Vehicle" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetFilterData() {
    this.DataListModel.currentPage = 1;
    this.GetVehicleList();
  }

  public GetVehicleList() {
    this.isLoading = true;
    this.vehicleService.GetVehicleList();
    this.vehicleService
      .GetVehicleList(
        this.DataListModel,
        this.ownerCompanyHashID,
        this.sharedVehicleGroupHashId,
        null,
        false,
        this.chkCleanRequireFilter,
        this.chkFuelRequireFilter,
        this.chkDamageFilter
      )
      .subscribe(
        res => {
          this.vehicleList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public DeleteVehicle(deletedVehicleList: string[]) {
    this.isLoading = true;
    this.vehicleService.DeleteVehicle(deletedVehicleList).subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetVehicleList();
        this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
          this.module
        ]);
        this.ShowSuccessPopup();
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public OnParentCheck(isChecked: boolean) {
    this.vehicleList
      .filter(x => x.isDeletable)
      .forEach(x => (x.isChecked = isChecked));
  }

  public ShowChildModal(vehicleMasterHashId?: string): void {
    if (vehicleMasterHashId) {
      this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
        this.module
      ]);
      this.isMultipleDelete = false;
      this.deleteVehicleMasterHashId = vehicleMasterHashId;
    } else {
      this.popupMsg = this.translate.instant(
        "LblRecordMultiplDeleteConfirmation",
        [this.module]
      );
      this.isMultipleDelete = true;
    }
    this.childModal.show();
  }

  public HideChildModal(): void {
    this.deleteVehicleMasterHashId = "";
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    let deletedVehicleList: any[];
    if (this.isMultipleDelete)
      deletedVehicleList = this.vehicleList
        .filter(x => x.isChecked)
        .map(x => x.vehicleMasterHashId);
    else deletedVehicleList.push(this.deleteVehicleMasterHashId);

    this.DeleteVehicle(deletedVehicleList);
    this.childModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/components/vehicle-list.component.ts